






























































import AppCheckbox from "@/components/AppCheckbox.vue";
import Search from "@/components/Search.vue";
import Processing from "@/components/table/Processing.vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
export default Vue.extend({
  components: {
    AppCheckbox,
    Processing,
    Search,
  },
  setup() {
    const {
      can_user_submit,
      submit,
      is_loading,
      labels,
      selected_label_id,
      file_url,
    } = state;

    const query_label = ref("");

    const display_labels = computed(() => {
      if (query_label.value.length > 0) {
        const lower_cased_query = query_label.value.toLowerCase();
        return labels.value
          .map((d) =>
            d.filter((f, index) => {
              if (index == 0) {
                return true;
              } else {
                return f.labelName.toLowerCase().search(lower_cased_query) > -1;
              }
            })
          )
          .filter((f) => f.length > 1);
      } else {
        return labels.value;
      }
    });

    onMounted(async () => {
      await state.init();
    });

    onBeforeUnmount(() => state.destroy());

    return {
      is_loading,
      labels,
      file_url,
      selected_label_id,
      can_user_submit,
      submit,
      query_label,
      display_labels,
    };
  },
});
